import { BlueprintEntity } from '@agilelab/plugin-wb-builder-common';
import { Box, createStyles, makeStyles, Theme } from '@material-ui/core';
import { useEntityByRef } from '@agilelab/plugin-wb-platform';
import {
  BlueprintCard,
  BlueprintSkeleton,
} from '@agilelab/plugin-wb-scaffolder';

type PrototypeBlueprintProps = {
  entityRef?: string;
};

const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        width: 350,
        maxWidth: 350,
        // to not overflow on small screens it should occupy at most 100% of the space available
        [theme.breakpoints.down('sm')]: {
          width: '100%',
        },
      },
    }),
  { name: 'PrototypeBlueprint' },
);

export const PrototypeBlueprint: React.FC<PrototypeBlueprintProps> = ({
  entityRef,
}) => {
  const classes = useStyles();
  const { data, isLoading, error } = useEntityByRef(entityRef);

  if (!entityRef)
    return <BlueprintSkeleton loading={false} className={classes.root} />;
  if (isLoading) return <BlueprintSkeleton loading className={classes.root} />;
  if (error) return <Box>Error loading blueprint</Box>;

  return (
    <BlueprintCard
      blueprint={data as BlueprintEntity}
      className={classes.root}
      hideFavourite
      hideFooter
    />
  );
};
